import { isNil } from '@flowio/is';

/**
 * Valid Adyen locales based on
 * https://docs.adyen.com/online-payments/components-web/localization-components
 */
const adyenLocales = [
  'ar',
  'zh-CN',
  'zh-TW',
  'hr-HR',
  'cs-CZ',
  'da-DK',
  'nl-NL',
  'en-US',
  'fi-FI',
  'fr-FR',
  'de-DE',
  'el-GR',
  'hu-HU',
  'it-IT',
  'ja-JP',
  'ko-KR',
  'no-NO',
  'pl-PL',
  'pt-BR',
  'ro-RO',
  'ru-RU',
  'sk-SK',
  'sl-SI',
  'es-ES',
  'sv-SE',
];

export default function getAdyenLocale(locale?: string): string {
  const { languages } = window.navigator;
  const isProvidedLocaleValid = !isNil(locale) && adyenLocales.indexOf(locale) !== -1;
  const validUserLocale = languages.find((language: string) => adyenLocales.indexOf(language) !== -1) || 'en-US';

  if (!isNil(locale) && isProvidedLocaleValid) {
    return locale;
  }
  return validUserLocale;
}
